import React from "react";
import { DashboardEditorProps } from "components/ComponentType";
import { TabPanel, TabView } from "primereact/tabview";
import DatasetChartConfig from "components/basic/dataset-chart-config/DatasetChartConfig";
import { T } from "services/lang/LanguageService";
import { DatasetScatterProps, YAxisIdentifier, YAxisIdentifierSelectionType } from "../interfaces";
import DatasetsScatterChartDatasetsEditor from "./DatasetScatterChartDatasetsEditor";
import DatasetScatterChartColorEditor from "./DatasetScatterChartColorEditor";
import DatasetScatterChartImageEditor from "./DatasetScatterChartImageEditor";
import DatasetScatterChartRangesAndHighlightsEditor from "./DatasetScatterChartRangesAndHighlightsEditor";

const DatasetScatterChartEditor: React.FC<DashboardEditorProps<DatasetScatterProps>> = props => {
  const { config, onConfigChange } = props;

  const handleChange = (
    field: keyof DatasetScatterProps,
    value: string | string[] | number | boolean | null | YAxisIdentifier[]
  ) => {
    let updatedConfig = { ...config, [field]: value };

    if (value === null) delete updatedConfig[field];

    if (field === "colorAxisIdentifier" && value === null) {
      updatedConfig = { ...updatedConfig, discreteColorMode: false };
    }
    if (
      field === "yAxisIdentifierSelectionType" &&
      value === YAxisIdentifierSelectionType.MULTIPLE
    ) {
      delete updatedConfig.colorAxisIdentifier;
      delete updatedConfig.sizeAxisIdentifier;
      updatedConfig = {
        ...updatedConfig,
        discreteColorMode: false,
      };
    }
    onConfigChange(updatedConfig);
  };

  return (
    <TabView>
      <TabPanel header={T("word.datasets")}>
        <DatasetsScatterChartDatasetsEditor config={config} handleChange={handleChange} />
      </TabPanel>
      <TabPanel header={T("label.ranges-and-highlights")}>
        <DatasetScatterChartRangesAndHighlightsEditor
          config={config}
          onConfigChange={onConfigChange}
          handleChange={handleChange}
        />
      </TabPanel>
      <TabPanel header={T("label.color-options")}>
        <DatasetScatterChartColorEditor config={config} onConfigChange={onConfigChange} />
      </TabPanel>
      <TabPanel header={T("word.image-options")}>
        <DatasetScatterChartImageEditor config={config} onConfigChange={onConfigChange} />
      </TabPanel>
      <TabPanel header={T("word.settings")}>
        <DatasetChartConfig config={config} onConfigChange={onConfigChange} />
      </TabPanel>
    </TabView>
  );
};

export default DatasetScatterChartEditor;
